import { cloneDeep } from 'lodash'

class CalloutBubbleMessanger {
  constructor() {
    this.messageQueue = [] // Queue to hold messages before iframe is ready
    this.iframeLoaded = false // Flag to check if the iframe is loaded
    this.targetWindow = null // Reference to callout bubble window (cross-origin safe)

    // Listen for a readiness signal from the parent/loader to know when the callout iframe is available
    window.addEventListener('message', (event) => {
      const evtType = event?.data?.eventType
      if (evtType === 'CALLOUT_IFRAME_READY') {
        this.resolveTargetWindow()
        this.iframeLoaded = true
        this.flushQueue()
      }
    })
  }

  // Try to resolve the target window via named frame; this is cross-origin safe for postMessage
  resolveTargetWindow() {
    try {
      const frames = window.top?.frames
      if (frames) {
        // Set by LoadIframe.js: calloutBubbleIframe.name = 'netomi-callout-bubble'
        this.targetWindow = frames['netomi-callout-bubble'] || this.targetWindow
      }
    } catch (_e) {
      // ignore cross-origin access errors
    }
    return this.targetWindow
  }

  // Flush queued messages once iframe is ready and window reference is available
  flushQueue() {
    if (!this.targetWindow) this.resolveTargetWindow()
    while (this.targetWindow && this.messageQueue.length > 0) {
      const message = this.messageQueue.shift()
      try {
        this.targetWindow.postMessage(cloneDeep(message), '*')
      } catch (_e) {
        // If posting fails, re-queue and stop to retry later
        this.messageQueue.unshift(message)
        break
      }
    }
  }

  // Send a single message to the iframe (or queue until ready)
  sendMessageToIframe(message) {
    if (!this.targetWindow) this.resolveTargetWindow()
    if (this.targetWindow && this.iframeLoaded) {
      try {
        this.targetWindow.postMessage(message, '*')
      } catch (_e) {
        this.messageQueue.push(message)
      }
    } else {
      this.messageQueue.push(message)
    }
  }

  // Public API
  sendMessage(messageEvent) {
    this.sendMessageToIframe(messageEvent)
  }
}

const calloutBubbleMessanger = new CalloutBubbleMessanger()

export default calloutBubbleMessanger
